import { h, Host } from '@stencil/core';
import { LineCount, tryParse } from '@pes-ui/utils';
export class CategoryDescription {
  componentWillLoad() {
    var _a, _b, _c, _d, _e, _f;
    this.name = (_a = tryParse(this._name)) !== null && _a !== void 0 ? _a : this.name;
    this.description = (_b = tryParse(this._description)) !== null && _b !== void 0 ? _b : this.description;
    this.readMoreLabel = (_c = tryParse(this._readMoreLabel)) !== null && _c !== void 0 ? _c : this.readMoreLabel;
    this.readLessLabel = (_d = tryParse(this._readLessLabel)) !== null && _d !== void 0 ? _d : this.readLessLabel;
    this.badge = (_e = tryParse(this._badge)) !== null && _e !== void 0 ? _e : this.badge;
    this.isCategory = (_f = tryParse(this._isCategory)) !== null && _f !== void 0 ? _f : this.isCategory;
  }
  getWrapped(text) {
    if (this.isCategory)
      return `<!--L1-NAME_BEGIN-->${text} <!--L1-NAME_END-->`;
    return `<!--L2-NAME_BEGIN-->${text}<!--L2-NAME_END-->`;
  }
  constructor() {
    this.name = undefined;
    this.description = undefined;
    this.readMoreLabel = undefined;
    this.readLessLabel = undefined;
    this.badge = undefined;
    this.isCategory = false;
    this._name = undefined;
    this._description = undefined;
    this._readMoreLabel = undefined;
    this._readLessLabel = undefined;
    this._badge = undefined;
    this._isCategory = undefined;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h(Host, null, h("div", { class: "category-description__header" }, h("qds-title", { class: "category-description__header-title", innerHTML: this.getWrapped(this.name), layer: "main", level: "section", tag: "h1", alignment: "start", variant: "web-main-section-hero" }), this.badge && (h("pes-badge-wrapper", { class: "category-description__badge", type: this.badge.type, label: this.badge.label, size: "large" }))), this.description && (h("pes-description", { class: "category", text: this.description, expandLabel: this.readMoreLabel, collapseLabel: this.readLessLabel, numLinesToShow: {
        desktop: LineCount.DESKTOP_LINE_COUNT,
        mobile: LineCount.MOBILE_LINE_COUNT,
      } }))));
  }
  static get is() { return "pes-category-description"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["category-description.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["category-description.css"]
    };
  }
  static get properties() {
    return {
      "name": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": true,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "header"
        },
        "attribute": "name",
        "reflect": false
      },
      "description": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "collapsible/expandable text"
        },
        "attribute": "description",
        "reflect": false
      },
      "readMoreLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label for \"Read more\""
        },
        "attribute": "read-more-label",
        "reflect": false
      },
      "readLessLabel": {
        "type": "string",
        "mutable": true,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Label for \"Read less\""
        },
        "attribute": "read-less-label",
        "reflect": false
      },
      "badge": {
        "type": "unknown",
        "mutable": true,
        "complexType": {
          "original": "TProductBadge | null",
          "resolved": "{ type: string; label: string; }",
          "references": {
            "TProductBadge": {
              "location": "import",
              "path": "../category-subcategory-listing/types"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Badge data"
        }
      },
      "isCategory": {
        "type": "boolean",
        "mutable": true,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Is component used on a category page"
        },
        "attribute": "is-category",
        "reflect": false,
        "defaultValue": "false"
      },
      "_name": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-name",
        "reflect": false
      },
      "_description": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-description",
        "reflect": false
      },
      "_readMoreLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-read-more-label",
        "reflect": false
      },
      "_readLessLabel": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-read-less-label",
        "reflect": false
      },
      "_badge": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-badge",
        "reflect": false
      },
      "_isCategory": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "plain-is-category",
        "reflect": false
      }
    };
  }
  static get elementRef() { return "el"; }
}
